<template>
  <section class="section pretty-top pretty-bottom" id="onOffChart">
  <div class="container condensed">
    <div class="columns">
      <div class="column">
        <h2>{{ $t("profile.OSRMammalStatus.onOffChart.sectionHeader") }} </h2>
        <div class="profile richtext bold" v-html="sppContent?.OSROnOffIntroduction"></div>
        <hr/>
        <div class="richtext" v-html='$t("profile.OSRMammalStatus.onOffChart.results",{ sppName: state?.sppName})'/>
      </div>
    </div>
  </div>
    <!-- <div class="columns is-multiline is-centered" v-if="isLoaded && chartOption.option"> -->
      <!-- <div class="column is-12 center"> -->
  <div class="container">
    <div class="button-container">
      <a class="toggle button is-primary" @click="toggleCI">{{!toHideErrorBar ? 'SHOW' : 'HIDE'}} C.I.</a>
    </div>
    <div class="column">
      <div class="columns is-centered">
        <div class="column is-12-tablet is-9-desktop chart"  v-if="isLoaded">
        <!-- <h4>{{ $t("profile.ABStatus.impactHF.linearHFChart.header", { regionType: "Forested" }) }} </h4> -->
            <vue-highcharts
              type="chart"
              :options="chartOption.options"
              :redrawOnUpdate="true"
              :oneToOneUpdate="true"
              :animateOnUpdate="true"
              @rendered="onRender"
              @update="onUpdate"
              @destroy="onDestroy"/>

          <div v-if="false" class="interpretion profile richtext" v-html="sppContent?.WebFLinearHFGraphText"></div>
          <div class="">
            <figure class="">
              <div v-html='$t("profile.OSRMammalStatus.onOffChart.caption", { sppName: state?.sppName})'/>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container condensed">
    <div class="columns">
      <div class="column">
        <div class="richtext" v-html="sppContent?.OSROnOffHighlights"></div>
      </div>
    </div>
  </div>
  </section>
</template>

<script>
/*
Linear HF charts show them side by side if there are both north and south charts
both charts will have same scales.
*/
import { reactive, watch, ref } from 'vue';
import { getOSROnOffHFData } from '@/services/data/graph-data.js'
import Vue3Highcharts from '@/components/vue3-highcharts/index';
import { useApp } from '@/composables/state/profileState';
import { credits, defaultXAxis, defaultYAxis, tickFontStyle, smallTickFontStyle, axisFontStyle, DATA_MODEL as dataModel } from '@/config/profile-config';
import { mergeDeep } from '@/lib/common';
import { useI18n } from 'vue-i18n';
import patternFillInit from 'highcharts/modules/pattern-fill';
import Highcharts from 'highcharts';
patternFillInit(Highcharts);

export default {
  name: 'osr-on-off-hf-section-2',
  components: {
    'vue-highcharts': Vue3Highcharts
  },
  props: ['isSpecies'],
  setup (props) {
    const { tm } = useI18n();
    const { state, sppContent } = useApp();
    const isLoaded = ref(0);
    const xAxisObj = {};
    const chart = ref();
    const categories = reactive([]);

    const seriesObj = reactive({});

    const yAxisLabel = tm('profile.ABStatus.habHFAssociation.vegFewChart.yAxis');
    const toHideErrorBar = ref(true);
    const chartOption = reactive({});

    const loadData = async () => {
      if (!state.tsn) {
        return;
      }

      const data = await getOSROnOffHFData(state.tsn, state.year); /* state.tsn */
      // const colors = [
      //   ['#c90'],
      //   ['#396c3b', '#699d6b'],
      //   ['#396c3b', '#699d6b'],
      //   ['#396c3b', '#699d6b'],
      //   // ['#034f8d', '#81add1'],
      //   // ['#a52a03', '#f19c82'],
      // ]
      const colors = ['#396c3b', '#EEEE9B', '#ffb347', '#f2b195', '#EEEE9B', '#f2b195', '#ffb347']
      let index = 0;
      data?.forEach(item => {
        let matchIndex = categories.findIndex(x => x.name === item.subCategory);
        const key = item.subCategory ?? 'xx';
        if (matchIndex < 0) {
          categories.push({ name: item.subCategory, categories: [item.label] });
          matchIndex = categories.length - 1;
          seriesObj[key] = {
            errorBar: {
              name: item.subCategory ?? 'xx',
              // pointPlacement: -0.1,
              type: 'errorbar',
              data: [],
              xAxis: matchIndex,
              centerInCategory: key === '',
            },
            bar: {
              name: item.subCategory,
              type: 'column',
              data: [],
              showInLegend: false,
              xAxis: matchIndex,
              // colors: colors[matchIndex]
            }
          };

          xAxisObj[key] = {
            title:
            { text: item.subCategory, overflow: true, style: { ...tickFontStyle, fontSize: '0.9rem' } },
            labels: { allowOverlap: true, rotation: 0, overflow: true, style: tickFontStyle },
            offset: 0, /* imporatant, this make sub axis align at same horizontal level */
            // width: 25, // (100 * (nColumn - referenceSeries.bar.data.length) / nColumn - 2).toFixed(),
            // lineWidth: matchIndex * 2 + 1,
            // lineColor: '#f00',
            categories: [],
            margin: 130,
          };
        }
        // matchIndex = categories.findIndex(x => x.name === item.subCategory);
        // let offset = 0;
        // if (item.label !== 'On') {
        //   offset = 0;
        // }
        seriesObj[key].errorBar.data.push({ low: item.mean - item.lower, high: item.mean + item.upper });
        if (item.label === 'On') {
          seriesObj[key].bar.data.push({
            y: item.mean,
            color: {
              pattern: {
                path: {
                  d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                  strokeWidth: 1,
                },
                color: colors[index],
                width: 10,
                height: 10
              }
            },
            borderColor: colors[index++],
            borderWidth: 2
          });
        } else {
          seriesObj[key].bar.data.push({
            y: item.mean,
            color: colors[index++],
          });
        }
        xAxisObj[key].categories.push(item.label ?? '');
      });

      // set axis starting position
      let nColumn = 0;
      let left = 5;
      Object.keys(xAxisObj).forEach(x => {
        xAxisObj[x].width = seriesObj[x].bar.data.length;
        nColumn += seriesObj[x].bar.data.length;
      })
      const xAxis = Object.values(xAxisObj);
      xAxis.forEach((x, index) => {
        /* make axis start 1% after it org space, and make the bars 1% smaller
        just to create space between groups */

        x.left = (left) + '%';
        left += parseInt((index === 0 ? 60 : 100) * (2 / nColumn));
        x.width = parseInt((index === 0 ? 30 : 50) * (2 / nColumn)) + '%';
      });

      const series = [];
      Object.values(seriesObj).forEach(x => {
        const pointWidth = x.bar.data.length > 1 ? 40 : 35;
        x.bar.pointWidth = pointWidth;
        series.push(x.bar);
        series.push(x.errorBar);
      });
      chartOption.options = {
        credits,
        chart: {
          // width: 700, // Set chart width
          height: 500,
        },
        title: {
          text: '' // chart.title?.replace('$', label)
        },
        xAxis,
        yAxis: mergeDeep(defaultYAxis, {
          title: {
            text: yAxisLabel
          },
          tickAmount: 4,
          min: 0,
          reversedStacks: false
        }),
        plotOptions: {
          column: {
            // color: {
            //   pattern: {
            //     path: {
            //       d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
            //       strokeWidth: 1,
            //     },
            //     color: '#c90',
            //     width: 10,
            //     height: 10
            //   }
            // },
            colorByPoint: true,
            // colors: ['#0e5a11', '#6ea571'],
            // pointPadding: 5,
            grouping: false, // without this label and bars mis-aligned
            // centerInCategory: key === ''
            // dataLabels: {
            // // enabled: true,
            //   crop: false
            // // overflow: 'none',
            // // useHTML: true,
            // // formatter: function () {
            // //   return (this.point.y > 0 ? '+' : '') + this.point.y.toFixed(2) + '%';// + useHFCustomIcon(extenedHfCategory, 15, this.point.name)
            // // }
            // }
          }
        },
        tooltip: {
          backgroundColor: '#FCFFC5',
          headerFormat: '',
          pointFormatter: function () {
            return `${this.series.name} ${this.category.name}: ${this.y.toFixed(2)}%`;
          }
        // pointFormat: `${point.name}: {point.y}%`
        },
        series
      };

      isLoaded.value = true;
    }
    watch(() => state.tsn, async (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        loadData();
      }
    });
    const toggleCI = () => {
      if (chart.value) {
        chart.value.series.forEach(x => {
          if (x.type === 'errorbar') {
            if (toHideErrorBar.value === true) {
              x.hide();
            } else {
              x.show();
            }
          }
        });
        toHideErrorBar.value = !toHideErrorBar.value;
      }
    };
    const onRender = (inChart) => {
      chart.value = inChart;
    };
    return {
      state,
      sppContent,
      loadData,
      chartOption,
      // hideErrorChartOption,
      toHideErrorBar,
      isLoaded,
      dataModel,
      onRender,
      toggleCI
    }
  },
  created () {
    this.loadData();
  }
}
</script>

<style scoped>
.toggle.button {
  padding: 10px 10px;
  height: 20px;
  min-height: 10px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
}
</style>
